module.exports = __webpack_public_path__ + "media/images/progress_bar_image-e9a2d9fbdaebb1340f4e8ff3ba684946.jpg";